import { api } from 'src/api/axios';

export interface EditStatusType {
  status: string | number;
}

export const useChangeOrderStatus = (params: EditStatusType, id: number) =>
  api.post(`/api/cms/order/change-status/${id}`, params);
